import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { SET_PROVIDER } from './constants';

const initialState = {
  organizationId: '',
  organizationName: '',
  corporateProviderMpin: '',
  corporateProviderName: '',
  corporateProviderLastName: '',
  taxIdNumber: '',
  servicingProviderMpin: '',
  servicingProviderName: '',
  servicingProviderFirstName: '',
  servicingProviderLastName: '',
  permissions: [],
  privileges: [],
  allPermission: false,
  permissionSubCode: [],
  permissionCode: [],
  isThirdParty: false,
  isActive: false,
};

export const providerReducer = createReducer(initialState, {
  [SET_PROVIDER]: (state, action) => {
    return action.payload;
  },
});
